import { useCallback } from 'react';
import { getRequestParams } from '../../../../helpers/globalfunctions.js';
import { CardTypes, DateFormat } from '../../../../helpers/fixcodes.js';
import { existingCreditCardData, terminalTypeData, CARD_PLACEHOLDER_IMAGE } from '../constants';
import Swal from 'sweetalert2';
import jsSHA from 'jssha';
import moment from 'moment/min/moment-with-locales';

const google = window.google;
const $ = window.$;

export function useCharterApi(state, setState, rideTypeIdRef, isLoadingTimeRef, vehicleDriverRef, duplicationModalRef, props) {
  const getAirlines = useCallback(async () => {
    try {
      const data = JSON.parse(sessionStorage.getItem('session_airlines'));
      if (data === null) {
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('air-line-api/' + 0, requestParams);
        const json = await response.json();
        setState({ dropdownAirline: json.airLine });
      } else {
        setState({ dropdownAirline: data.airLine });
      }
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getVehicleType = useCallback(async () => {
    try {
      const data = JSON.parse(sessionStorage.getItem('session_vehicletype'));
      if (data === null) {
        const newObject = {};
        const requestParams = getRequestParams('POST', newObject);
        const response = await fetch('vehicletype-api/vehicletype', requestParams);
        const json = await response.json();
        setState({ dropdownVehicleType: json.apiVehicleType || [] });
      } else {
        setState({ dropdownVehicleType: data?.data?.apiVehicleType || data?.apiVehicleType || [] });
      }
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getAffiliates = useCallback(async () => {
    try {
      const requestParams = getRequestParams('GET', '');
      const response = await fetch('account-api/affliate-dropdown', requestParams);
      const json = await response.json();
      setState({ dropdownAffiliates: json.affiliatesDropdownList || [] });
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getReservationModes = useCallback(async () => {
    try {
      const requestParams = getRequestParams('GET', '');
      const response = await fetch('reservation-mode-api', requestParams);
      const json = await response.json();
      setState({ dropdownReservationMode: json.reservationMode || [] });
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getZones = useCallback(async () => {
    try {
      const data = JSON.parse(sessionStorage.getItem('session_zones'));
      if (data === null) {
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('serviceAreaZone-api/zone-dropdown/0/0', requestParams);
        const json = await response.json();
        setState({ dropdownZone: json.locationServiceAreaZoneList || [] });
      } else {
        setState({ dropdownZone: data.locationServiceAreaZoneList || [] });
      }
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getGreeter = useCallback(async () => {
    try {
      const requestParams = getRequestParams('GET', '');
      const response = await fetch('account-api/greeter-dropdown/', requestParams);
      const json = await response.json();
      setState({ dropdownGreeter: json.users || [] });
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getAgentCommission = useCallback(async () => {
    try {
      const requestParams = getRequestParams('GET', '');
      const response = await fetch('commission-agent-api/commission-agent-dropdown/', requestParams);
      const json = await response.json();
      setState({ dropdownAgentCommission: json.commissionAgentDropdownList || [] });
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getPaymentType = useCallback(async () => {
    try {
      const requestParams = getRequestParams('GET', '');
      const response = await fetch('paymenttype-api/dropdownlist', requestParams);
      const json = await response.json();
      setState({ dropdownPaymentType: json.paymentType || [] });
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getVoucherCompany = useCallback(async () => {
    try {
      const requestParams = getRequestParams('GET', '');
      const response = await fetch('account-api/voucher-customer-dropdown/', requestParams);
      const json = await response.json();
      setState({ dropdownVoucherCompany: json.customers || [] });
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getExistingCards = useCallback(() => {
    try {
      setState({ dropdownExistingCards: existingCreditCardData });
    } catch (e) {
      console.log(e);
    }
  }, [setState]);

  const getRideTypeId = useCallback((fromZId, toZId) => {
    rideTypeIdRef.current = 0;
    setState({ isMeetGreet: false });

    if (fromZId > 0 && toZId > 0) {
      const puZone = state.dropdownZone.find((opt) => opt.id === fromZId);
      const doZone = state.dropdownZone.find((opt) => opt.id === toZId);

      if (puZone && doZone) {
        setState({ isMeetGreet: false });
        if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
          rideTypeIdRef.current = 1;
        } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
          rideTypeIdRef.current = 2;
        } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
          rideTypeIdRef.current = 3;
        } else {
          rideTypeIdRef.current = 13;
        }
      }
    }
  }, [state.dropdownZone, rideTypeIdRef, setState]);

  const fillRateControls = useCallback((rates) => {
    if (state.rideId > 0) {
      if (state.isLockRates === false) {
        setState({
          meetGreet: parseFloat(rates.meetGreetCharge),
          rideAmount: parseFloat(rates.rate),
          tollAmount: parseFloat(rates.tollAmount),
          tipAmount: parseFloat(rates.tipAmount),
          parkingFee: parseFloat(rates.parking),
          fuelSurcharge: parseFloat(rates.fuelSurCharge),
          tourGuideCharge: 0.0,
          payToTourGuide: 0.0,
          waitingCharge: parseFloat(rates.waitCharge),
          extraStopCharge: parseFloat(rates.stop),
          otAmount: 0.0,
          serviceFeeAmount: parseFloat(rates.serviceFee),
          agentCommissionAmount: parseFloat(rates.agentCommission),
          grossAmount: parseFloat(rates.fare),
          discount: parseFloat(rates.discountCharge),
          totalFare: parseFloat(rates.totalFare),
          paidAmount: 0.0,
        });
      } else {
        if (parseInt(props.tripDetails.invoiceNo) <= 0) {
          setState({
            portAuthority: parseFloat(rates.portAuthority),
            utitity: parseFloat(rates.utilityTax),
            workCompantation: parseFloat(rates.wcTax),
            salesTax: parseFloat(rates.salesTax),
            countyTax: parseFloat(rates.countyTax),
            congestionTax: parseFloat(rates.congestionTax),
          });
          setTimeout(() => calculateFare('', 0), 500);
        }
      }
    } else {
      setState({
        rideAmount: parseFloat(rates.rate),
        tollAmount: parseFloat(rates.tollAmount),
        tipAmount: parseFloat(rates.tipAmount),
        otAmount: 0.0,
        serviceFeeAmount: parseFloat(rates.serviceFee),
        fuelSurcharge: parseFloat(rates.fuelSurCharge),
        parkingFee: parseFloat(rates.parking),
        tourGuideCharge: 0.0,
        payToTourGuide: 0.0,
        extraAmount: 0.0,
        extraAmountFor: '',
        waitingCharge: parseFloat(rates.waitCharge),
        waitingTime: 0,
        waitingChargeTotal: 0.0,
        extraStopCharge: parseFloat(rates.stop),
        noOfStops: 0,
        stopTotal: 0.0,
        meetGreet: parseFloat(rates.meetGreetCharge),
        mgToPay: '2',
        payMeetGreetId: 0,
        payMeetGreetAmount: 0.0,
        mgDriverComms: '1',
        agentCommissionId: rates.agentId,
        agentCommissionName: rates.agentName,
        agentCommissionAmount: parseFloat(rates.agentCommission),
        discount: 0.0,
        portAuthority: parseFloat(rates.portAuthority),
        utitity: parseFloat(rates.utilityTax),
        workCompantation: parseFloat(rates.wcTax),
        salesTax: parseFloat(rates.salesTax),
        countyTax: parseFloat(rates.countyTax),
        congestionTax: parseFloat(rates.congestionTax),
        grossAmount: parseFloat(rates.fare),
        totalFare: parseFloat(rates.totalFare),
        paidAmount: 0.0,
      });
    }
  }, [state.rideId, state.isLockRates, props, setState]);

  const calculateFare = useCallback(async (ctrl, value) => {
    try {
      const paxCount = parseInt(state.noOfPax | 0);
      const newObject = {
        TripAmt: (ctrl === 'rideAmount') ? parseFloat(value) : parseFloat(state.rideAmount),
        TollAmt: (ctrl === 'tollAmount') ? parseFloat(value) : parseFloat(state.tollAmount),
        TipAmt: (ctrl === 'tipAmount') ? parseFloat(value) : parseFloat(state.tipAmount),
        ExtraAmt: (ctrl === 'extraAmount') ? parseFloat(value) : parseFloat(state.extraAmount),
        Misc: (ctrl === 'parkingFee') ? parseFloat(value) : parseFloat(state.parkingFee),
        FuelSurCharge: (ctrl === 'fuelSurcharge') ? parseFloat(value) : parseFloat(state.fuelSurcharge),
        TourGuideAmt: (ctrl === 'tourGuideCharge') ? parseFloat(value) : parseFloat(state.tourGuideCharge),
        MeetGreet: (ctrl === 'meetGreet') ? parseFloat(value) : parseFloat(state.meetGreet),
        OT: (ctrl === 'otAmount') ? parseFloat(value) : parseFloat(state.otAmount),
        SvcFee: (ctrl === 'serviceFeeAmount') ? parseFloat(value) : parseFloat(state.serviceFeeAmount),
        WaitCharge: (ctrl === 'waitingCharge') ? parseFloat(value) : parseFloat(state.waitingCharge),
        WaitTime: (ctrl === 'waitingTime') ? parseFloat(value) : parseInt(state.waitingTime),
        StopCharge: (ctrl === 'extraStopCharge') ? parseFloat(value) : parseFloat(state.extraStopCharge),
        NoOfStop: (ctrl === 'noOfStops') ? parseFloat(value) : parseInt(state.noOfStops),
      };

      if (state.customerRateTax != null) {
        newObject.AgentCommissionPercentage = parseFloat(state.customerRateTax.agentCommissionPercentage == null ? 0 : state.customerRateTax.agentCommissionPercentage);
        newObject.IsWcTax = state.customerRateTax.allowWorkCommpactionTax;
        newObject.IsPATax = state.customerRateTax.allowPortAuthTax;
        newObject.IsUtilitTax = state.customerRateTax.allowUtilityTax;
        newObject.IsSalesTax = state.customerRateTax.allowSalesTax;
        newObject.IsCountyTax = state.customerRateTax.allowCountyTax;
        newObject.IsCongestionTax = state.customerRateTax.allowCongestionTax;
        newObject.TaxInclude = state.customerRateTax.taxInclude;
        newObject.WcCharge = parseFloat(state.customerRateTax.wcTaxCharge);
        newObject.PaCharge = parseFloat(state.customerRateTax.paTaxCharge);
        newObject.UtilityCharge = parseFloat(state.customerRateTax.utilityTaxCharge);
        newObject.SalesCharge = parseFloat(state.customerRateTax.salesTaxCharge);
        newObject.CountyCharge = parseFloat(state.customerRateTax.countyTaxCharge);
        newObject.CongestionCharge = parseFloat(state.customerRateTax.congestionTaxCharge);
        newObject.IsCongestionTaxFlatRate = state.customerRateTax.isTaxCongestionFlatRate;
        newObject.Discount = (ctrl === 'discount') ? parseFloat(value) : parseFloat(state.discount);
        newObject.NoOfPax = parseInt(paxCount);
        newObject.IsSharedRateApplicable = state.customerRateTax.isSharedRateApplicable;
      } else {
        newObject.AgentCommissionPercentage = parseFloat(0);
        newObject.IsWcTax = false;
        newObject.IsPATax = false;
        newObject.IsUtilitTax = false;
        newObject.IsSalesTax = false;
        newObject.IsCountyTax = false;
        newObject.IsCongestionTax = false;
        newObject.TaxInclude = parseInt(1);
        newObject.WcCharge = parseFloat(0);
        newObject.PaCharge = parseFloat(0);
        newObject.UtilityCharge = parseFloat(0);
        newObject.SalesCharge = parseFloat(0);
        newObject.CountyCharge = parseFloat(0);
        newObject.CongestionCharge = parseFloat(0);
        newObject.IsCongestionTaxFlatRate = false;
        newObject.Discount = (ctrl === 'discount') ? parseFloat(value) : parseFloat(state.discount);
        newObject.NoOfPax = parseInt(paxCount);
        newObject.IsSharedRateApplicable = false;
      }

      const requestParams = getRequestParams('POST', newObject);
      const response = await fetch('reservation-api/rate-calculation', requestParams);
      const data = await response.json();

      setState({
        waitingChargeTotal: parseFloat(data.waitTotal),
        stopTotal: parseFloat(data.stopTotal),
        portAuthority: parseFloat(data.paTax),
        salesTax: parseFloat(data.salesTax),
        utitity: parseFloat(data.utilityTax),
        workCompantation: parseFloat(data.wcTax),
        countyTax: parseFloat(data.countyTax),
        congestionTax: parseFloat(data.congestionTax),
        grossAmount: parseFloat(data.grossFare),
        totalFare: parseFloat(data.totalFare),
      });

      if (parseFloat(data.agentCommissionAmount) > 0) {
        setState({ agentCommissionAmount: parseFloat(data.agentCommissionAmount) });
      }

      if (parseInt(state.chkPaymentGatewaySelection) === 2) {
        if (state.rideId > 0) {
          if (state.paymentTypeId === 2 && state.creditCard.includes('x')) {
            // no change total paid
          } else if ((state.paymentTypeId === 2 && !state.creditCard.includes('x')) || state.paymentTypeId === 3) {
            setState({ paidAmount: parseFloat(state.totalFare).toFixed(3), paymentTermId: 1 });
          } else {
            if (parseInt(state.paymentTermId) === 1) {
              setState({ paidAmount: parseFloat(0).toFixed(3) });
            }
          }
        } else {
          if (state.paymentTypeId === 2 || state.paymentTypeId === 3) {
            setState({ paidAmount: parseFloat(state.totalFare).toFixed(3), paymentTermId: 1 });
          } else {
            setState({ paidAmount: parseFloat(0).toFixed(3) });
          }
        }
      } else {
        if (state.rideId > 0) {
          if (state.paymentTypeId === 2 && state.creditCard.includes('x')) {
            // no change total paid
          } else if (state.paymentTypeId === 2 && !state.creditCard.includes('x')) {
            setState({ paidAmount: parseFloat(state.totalFare).toFixed(3), paymentTermId: 1 });
          } else {
            if (parseInt(state.paymentTermId) === 1) {
              setState({ paidAmount: parseFloat(0).toFixed(3) });
            }
          }
        } else {
          if (state.paymentTypeId === 2) {
            setState({ paidAmount: parseFloat(state.totalFare).toFixed(3), paymentTermId: 1 });
          } else {
            setState({ paidAmount: parseFloat(0).toFixed(3) });
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [state, setState]);

  const getCustomerRateTaxSetting = useCallback(async (fromZId, toZId, puDateTime, vTypeId, pCount, hNumber, bMeetGreet) => {
    try {
      if (fromZId > 0 && toZId > 0 && puDateTime !== '' && vTypeId > 0 && pCount > 0) {
        let fromAirId = 0, toAirId = 0, fromZoneId = 0, toZoneId = 0;

        const puZone = state.dropdownZone.find((opt) => opt.id === fromZId);
        const doZone = state.dropdownZone.find((opt) => opt.id === toZId);

        if (puZone && doZone) {
          if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
            fromAirId = puZone.airportId;
            toZoneId = doZone.id;
          } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
            fromZoneId = puZone.id;
            toAirId = doZone.airportId;
          } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
            fromAirId = puZone.airportId;
            toAirId = doZone.airportId;
          } else {
            fromZoneId = puZone.id;
            toZoneId = doZone.id;
          }
        }

        const newObject = {
          RideTypeId: rideTypeIdRef.current,
          FromAirportId: fromAirId,
          ToAirportId: toAirId,
          FromZoneId: fromZoneId,
          ToZoneId: toZoneId,
          PickUpDateTime: puDateTime.toLocaleDateString() + ' ' + puDateTime.toLocaleTimeString(),
          ApiVehicleTypeId: vTypeId,
          NoOfHours: hNumber,
          NoOfPax: pCount,
          RateId: 0,
          IsMgRequired: bMeetGreet,
        };

        const requestParams = getRequestParams('POST', newObject);
        const response = await fetch('customer-api/' + state.customer.id + '/rate-tax-setting', requestParams);
        const data = await response.json();

        setState({ customerRateTax: data });
        fillRateControls(data);
      }
    } catch (e) {
      console.log(e);
    }
  }, [state.dropdownZone, state.customer, rideTypeIdRef, setState, fillRateControls]);

  const getBookingSuggestions = useCallback(async (value) => {
    const escapedValue = value.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (escapedValue === '') return [];

    const requestParams = getRequestParams('GET', '');
    const response = await fetch('address-search-api/' + state.customer.id + '/' + state.customer.customerTypeId + '/' + value, requestParams);
    const data = await response.json();

    setState({ bookingAddress: data === false ? [] : data.addressSearchList });

    const suggestions = data === false ? [] : data.addressSearchList;
    if (suggestions.length === 0) return [{ isNotFound: true }];
    return suggestions;
  }, [state.customer, setState]);

  const checkDuplicateReservation = useCallback(async (isButtonShow) => {
    let isResult = false;
    const stpuDate = new Date(new Date(state.puDateTime).toLocaleDateString());
    const pickupdate = ((stpuDate.getMonth() + 1) < 10 ? '0' + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? '0' + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear();

    if (state.paxFirstName.trim() === '') {
      setState((prev) => ({ errors: { ...prev.errors, paxFirstName: 'Please enter first name.' } }));
      return;
    }
    if (state.paxLastName.trim() === '') {
      setState((prev) => ({ errors: { ...prev.errors, paxLastName: 'Please enter last name.' } }));
      return;
    }

    const newObject = {
      CustomerId: parseInt(state.customer.id),
      FirstName: state.paxFirstName,
      LastName: state.paxLastName,
      FromDate: pickupdate + ' 00:00',
      ToDate: pickupdate + ' 23:59',
    };

    try {
      if (isButtonShow === false) props.duplicateFunction(true);
      const requestParams = getRequestParams('POST', newObject);
      const response = await fetch('reservation-api/duplicate-list', requestParams);
      const data = await response.json();

      if (data.duplicateTrips.length > 0) {
        props.duplicateFunction(false);
        await Swal.fire({
          title: '<small>Duplicate trips</small>',
          text: 'Duplicate trip(s) found!',
          icon: 'success',
          width: '25%',
          dangerMode: false,
          allowOutsideClick: false,
        });
        duplicationModalRef.current.showModal(data.duplicateTrips, isButtonShow);
        isResult = true;
      } else if (isButtonShow === false) {
        props.duplicateFunction(false);
        await Swal.fire({
          title: '<small>Duplicate trips</small>',
          text: 'Duplicate trip(s) not found!',
          icon: 'success',
          width: '25%',
          dangerMode: false,
          allowOutsideClick: false,
        });
      }
      return isResult;
    } catch (e) {
      console.log(e);
    }
  }, [state, setState, props, duplicationModalRef]);

  const bookReservation = useCallback(async () => {
    const paxCount = parseInt(state.noOfPax | 0);
    let pickupDate = [];

    if (state.tripTypeId === '3') {
      pickupDate = getRecurringPuDateArrayList(state);
    } else if (state.tripTypeId === '2') {
      const stpuDate = moment(new Date(state.puDateTime)).format(DateFormat.MomentDisplayDateTime24Format);
      pickupDate = [stpuDate];
    } else {
      const stpuDate = moment(new Date(state.puDateTime)).format(DateFormat.MomentDisplayDateTime24Format);
      pickupDate = [stpuDate];
    }

    if (pickupDate.length <= 0) {
      await Swal.fire({ title: '<small>Date Range</small>', text: 'Selected days are not between pickup date and end date!', icon: 'info', width: '25%', dangerMode: false, allowOutsideClick: false });
      props.submitFunction(false);
      return;
    }

    let fromAreaId = 0, toAreaId = 0, pickupLocationType = '', dropoffLocationType = '';
    const puZone = state.dropdownZone.find((opt) => opt.id === state.pickupZoneId);
    const doZone = state.dropdownZone.find((opt) => opt.id === state.dropoffZoneId);

    if (puZone && doZone) {
      if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
        fromAreaId = puZone.airportId; toAreaId = doZone.id; pickupLocationType = 'AIRPORT'; dropoffLocationType = 'HOTEL';
      } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
        fromAreaId = puZone.id; toAreaId = doZone.airportId; pickupLocationType = 'HOTEL'; dropoffLocationType = 'AIRPORT';
      } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
        fromAreaId = puZone.airportId; toAreaId = doZone.airportId; pickupLocationType = 'AIRPORT'; dropoffLocationType = 'AIRPORT';
      } else {
        fromAreaId = puZone.id; toAreaId = doZone.id; pickupLocationType = 'HOTEL'; dropoffLocationType = 'HOTEL';
      }
    }

    const newObject = {
      reservationId: state.rideId <= 0 ? 0 : props.tripDetails.reservationId,
      rideId: state.rideId,
      rideTypeId: rideTypeIdRef.current,
      fromAreaId,
      toAreaId,
      paxCount,
      paxCountReturn: 0,
      baggage: state.luggage,
      firstName: state.paxFirstName,
      lastName: state.paxLastName,
      firstNameReturn: '',
      lastNameReturn: '',
    };

    if (parseInt(state.tripTypeId) === 2) {
      const paxCountReturn = parseInt(state.noOfPaxReturn | 0);
      newObject.firstNameReturn = state.paxLastName;
      newObject.lastNameReturn = state.paxLastName;
      newObject.paxCountReturn = paxCountReturn;
    }

    newObject.countryCode = state.countryCodePhone;
    newObject.phoneNo = state.phoneNumber;
    newObject.cellCountryCode = state.countryCode;
    newObject.mobileNo = state.mobileNumber;
    newObject.customerId = parseInt(state.customer.id);
    newObject.airlineId = state.airlineId != null ? parseInt(state.airlineId) : 0;
    newObject.flightNumber = state.flightNumber;
    newObject.flightTime = moment(new Date(state.flightTime)).format(DateFormat.MomentDisplayDateTime24Format);
    newObject.terminalType = state.terminalType !== '' ? parseInt(state.terminalType) : 0;
    newObject.terminal = state.terminal;
    newObject.airlineIdReturn = state.airlineIdReturn != null ? parseInt(state.airlineIdReturn) : 0;
    newObject.flightNumberReturn = state.flightNumberReturn;
    newObject.flightTimeReturn = moment(new Date(state.flightTimeReturn)).format(DateFormat.MomentDisplayDateTime24Format);
    newObject.terminalTypeReturn = state.terminalTypeReturn !== '' ? parseInt(state.terminalTypeReturn) : 0;
    newObject.terminalReturn = state.terminalReturn;
    newObject.email = state.email;
    newObject.poNumber = state.poNumber;
    newObject.isPickupGoogleBooking = state.isPickupGoogleBooking;
    newObject.pickupLocation = state.pickupLocation;
    newObject.pickupLocationType = pickupLocationType;
    newObject.pickupAddress = state.pickupAddress;
    newObject.pickupCity = state.pickupCity;
    newObject.pickupState = state.pickupState;
    newObject.pickupZipCode = state.pickupZipCode;
    newObject.pickupLatitude = state.pickupLatitude;
    newObject.pickupLongitude = state.pickupLongitude;
    newObject.pickupGeoZoneId = puZone != null ? puZone.id : 0;
    newObject.pickupIsHotel = puZone != null ? puZone.zoneTypeId === 3 : false;
    newObject.isDropoffGoogleBooking = state.isDropoffGoogleBooking;
    newObject.dropoffLocation = state.dropoffLocation;
    newObject.dropoffLocationType = dropoffLocationType;
    newObject.dropoffAddress = state.dropoffAddress;
    newObject.dropoffCity = state.dropoffCity;
    newObject.dropoffState = state.dropoffState;
    newObject.dropoffZipCode = state.dropoffZipCode;
    newObject.dropoffLatitude = state.dropoffLatitude;
    newObject.dropoffLongitude = state.dropoffLongitude;
    newObject.dropoffGeoZoneId = doZone != null ? doZone.id : 0;
    newObject.dropoffIsHotel = doZone != null ? doZone.zoneTypeId === 3 : false;
    newObject.apt = state.apt;
    newObject.serviceSourceId = parseInt(state.serviceSourceId);
    newObject.serviceSourceName = parseInt(state.serviceSourceId) === 1 ? 'In House' : (parseInt(state.serviceSourceId) === 2 ? 'Farm In' : 'Farm Out');
    newObject.otherAffiliateId = parseInt(state.otherAffiliateId);
    newObject.isVipTrip = state.isVipTrip;
    newObject.isMeetGreet = state.isMeetGreet;
    newObject.isAccessible = state.isAccessible;
    newObject.isPriority = state.isPriorityTrip;
    newObject.pickupDateArray = pickupDate;
    newObject.pickupTime = state.puDateTime.toLocaleTimeString();
    newObject.pickupTimeReturn = moment(new Date(state.puDateTimeReturn)).format(DateFormat.DefaultTimeFormat);
    newObject.pickupDateReturn = moment(new Date(state.puDateTimeReturn)).format(DateFormat.MomentDisplayDateTime24Format);
    newObject.apiVehicleTypeId = parseInt(state.vehicleTypeId);
    newObject.tripTypeId = parseInt(state.tripTypeId);
    newObject.specialInstruction = state.specialInstruction;
    newObject.permanentRemark = state.permanentRemark;
    newObject.pickupNotes = state.pickupNotes;
    newObject.billToNotes = state.billToNotes;
    newObject.orderByName = state.orderByName;
    newObject.orderByCountryCode = state.countryCodeOrderPhone;
    newObject.orderByPhone = state.phoneNumberOrder;
    newObject.orderByEmail = state.emailOrder;
    newObject.approxDropoffTime = state.doDateTime;
    newObject.approxTripDurationMin = parseInt(state.tripDuration);
    newObject.reservationModeId = parseInt(state.reservationModeId);
    newObject.pilotCount = 0;
    newObject.crewCount = 0;
    newObject.flightAttandCount = 0;
    newObject.pilotCountReturn = 0;
    newObject.crewCountReturn = 0;
    newObject.flightAttandCountReturn = 0;
    newObject.rateId = state.customerRateTax ? state.customerRateTax.rateId : 0;
    newObject.paymentTypeId = parseInt(state.paymentTypeId);
    newObject.paymentGatewayId = parseInt(state.chkPaymentGatewaySelection);
    newObject.partialPay = parseInt(state.paymentTermId) === 1 ? false : true;
    newObject.voucherNo = parseInt(state.paymentTypeId) === 7 ? state.voucherCode : '';
    newObject.voucherCompany = parseInt(state.paymentTypeId) === 7 ? parseInt(state.voucherCompanyId) : 0;
    newObject.chqBankName = state.checkBank;
    newObject.chqNumber = state.checkNumber;
    newObject.chqDate = state.checkDate;
    newObject.creditCardNumber = (parseInt(state.chkPaymentGatewaySelection) === 2 && parseInt(state.paymentTypeId) === 2) ? state.creditCard : '';
    newObject.creditCardExpiry = (parseInt(state.chkPaymentGatewaySelection) === 2 && parseInt(state.paymentTypeId) === 2) ? state.cardExpiry : '';
    newObject.cardType = (parseInt(state.chkPaymentGatewaySelection) === 2 && parseInt(state.paymentTypeId) === 2) ? state.cardType : '';
    newObject.transferTypeId = state.customerRateTax ? state.customerRateTax.transferTypeId : 0;
    newObject.serviceTypeId = state.customerRateTax ? state.customerRateTax.serviceTypeId : 0;
    newObject.vehicleId = parseInt(vehicleDriverRef.current ? vehicleDriverRef.current.state.filterVehicleId : 0);
    newObject.driverId = parseInt(vehicleDriverRef.current ? vehicleDriverRef.current.state.filterDriverId : 0);
    newObject.rideAmount = parseFloat(state.rideAmount);
    newObject.tollAmnt = parseFloat(state.tollAmount);
    newObject.tipAmnt = parseFloat(state.tipAmount);
    newObject.meetGreetCharge = parseFloat(state.meetGreet);
    newObject.payToTourGuide = parseFloat(state.payToTourGuide);
    newObject.tourGuideName = '';
    newObject.tourGuideCharge = parseFloat(state.tourGuideCharge);
    newObject.mgPayTo = parseInt(state.mgToPay);
    newObject.meetGreetId = parseInt(state.payMeetGreetId);
    newObject.meetGreetName = '';
    newObject.meetGreetAmount = parseFloat(state.payMeetGreetAmount);
    newObject.mgDriverComms = parseInt(state.mgToPay) === 3 ? (state.mgDriverComms === '1' ? false : true) : false;
    newObject.gratuity = '';
    newObject.stop = parseFloat(state.extraStopCharge);
    newObject.noOfStop = parseInt(state.noOfStops);
    newObject.wtTotal = state.rideId <= 0 ? 0.0 : parseInt(state.waitingChargeTotal);
    newObject.wtTime = parseInt(state.waitingTime);
    newObject.wt = parseFloat(state.waitingCharge);
    newObject.ot = parseFloat(state.otAmount);
    newObject.serviceFee = parseFloat(state.serviceFeeAmount);
    newObject.fuelSurCharge = parseFloat(state.fuelSurcharge);
    newObject.parking = parseFloat(state.parkingFee);
    newObject.portAuthority = parseFloat(state.portAuthority);
    newObject.utilityTax = parseFloat(state.utitity);
    newObject.wcTax = parseFloat(state.workCompantation);
    newObject.salesTax = parseFloat(state.salesTax);
    newObject.countyTax = parseFloat(state.countyTax);
    newObject.congestionTax = parseFloat(state.congestionTax);
    newObject.extraAmnt = parseFloat(state.extraAmount);
    newObject.extraAmntFor = state.extraAmountFor;
    newObject.gross = parseFloat(state.grossAmount);
    newObject.discount = parseFloat(state.discount);
    newObject.totalFare = parseFloat(state.totalFare);

    // billableFare / totalPaid calculation (gateway branch)
    if (parseInt(state.chkPaymentGatewaySelection) === 2) {
      if (state.rideId > 0) {
        if (state.paymentTypeId === 1 && state.paymentTermId === 2 && parseFloat(state.paidAmount) > 0) {
          if (parseFloat(state.totalFare) <= parseFloat(state.paidAmount)) { newObject.billableFare = 0; newObject.totalPaid = parseFloat(state.paidAmount); }
          else { newObject.billableFare = parseFloat(state.totalFare) - parseFloat(state.paidAmount); newObject.totalPaid = parseFloat(state.paidAmount); }
        } else if (state.paymentTypeId === 2 && state.creditCard.includes('x')) {
          if (parseFloat(state.totalFare) <= parseFloat(state.paidAmount)) { newObject.billableFare = 0; newObject.totalPaid = parseFloat(state.paidAmount); }
          else { newObject.billableFare = parseFloat(state.totalFare) - parseFloat(state.paidAmount); newObject.totalPaid = parseFloat(state.paidAmount); }
          newObject.partialPay = true;
        } else if ((state.paymentTypeId === 2 && !state.creditCard.includes('x')) || state.paymentTypeId === 3) {
          newObject.billableFare = 0; newObject.totalPaid = parseFloat(state.paidAmount);
        } else {
          newObject.billableFare = parseFloat(state.totalFare); newObject.totalPaid = 0.0;
        }
      } else {
        if (!newObject.partialPay) {
          if (newObject.paymentTypeId === 2 || newObject.paymentTypeId === 3) { newObject.billableFare = 0; newObject.totalPaid = parseFloat(state.paidAmount); }
          else { newObject.billableFare = parseFloat(state.totalFare); newObject.totalPaid = 0.0; }
        } else {
          if (newObject.paymentTypeId === 2 || newObject.paymentTypeId === 3) { newObject.billableFare = parseFloat(state.totalFare) - parseFloat(state.paidAmount); newObject.totalPaid = parseFloat(state.paidAmount); }
        }
      }
    } else {
      if (state.rideId > 0) {
        if (state.paymentTypeId === 1 && state.paymentTermId === 2 && parseFloat(state.paidAmount) > 0) {
          if (parseFloat(state.totalFare) <= parseFloat(state.paidAmount)) { newObject.billableFare = 0; newObject.totalPaid = parseFloat(state.paidAmount); }
          else { newObject.billableFare = parseFloat(state.totalFare) - parseFloat(state.paidAmount); newObject.totalPaid = parseFloat(state.paidAmount); }
        } else if (state.paymentTypeId === 2 && state.creditCard.includes('x')) {
          if (parseFloat(state.totalFare) <= parseFloat(state.paidAmount)) { newObject.billableFare = 0; newObject.totalPaid = parseFloat(state.paidAmount); }
          else { newObject.billableFare = parseFloat(state.totalFare) - parseFloat(state.paidAmount); newObject.totalPaid = parseFloat(state.paidAmount); }
          newObject.partialPay = true;
        } else if (state.paymentTypeId === 2 && !state.creditCard.includes('x')) {
          newObject.billableFare = 0; newObject.totalPaid = parseFloat(state.paidAmount);
        } else {
          newObject.billableFare = parseFloat(state.totalFare); newObject.totalPaid = 0.0;
        }
      } else {
        if (!newObject.partialPay) {
          if (newObject.paymentTypeId === 2) { newObject.billableFare = 0; newObject.totalPaid = parseFloat(state.paidAmount); }
          else { newObject.billableFare = parseFloat(state.totalFare); newObject.totalPaid = 0.0; }
        } else {
          if (newObject.paymentTypeId === 2) { newObject.billableFare = parseFloat(state.totalFare) - parseFloat(state.paidAmount); newObject.totalPaid = parseFloat(state.paidAmount); }
        }
      }
    }

    newObject.chargeTo = '';
    newObject.agentName = state.agentCommissionName;
    newObject.agentId = parseInt(state.agentCommissionId);
    newObject.agentCommission = parseFloat(state.agentCommissionAmount);
    newObject.rateLocked = state.isLockRates;
    newObject.currencyId = 0;
    newObject.exchangeRate = 0;
    newObject.totalTax = parseFloat(state.portAuthority) + parseFloat(state.utitity) + parseFloat(state.workCompantation) + parseFloat(state.salesTax) + parseFloat(state.countyTax) + parseFloat(state.congestionTax);
    newObject.GratuityAmount = 0;
    newObject.tripChangesLogs = state.rideId <= 0 ? '' : getTripChangesDetails(state, props, rideTypeIdRef);

    try {
      props.submitFunction(true);
      const requestParams = getRequestParams('POST', newObject);
      const response = await fetch('reservation-api/book', requestParams);
      const data = await response.json();

      if (data.isSuccess && parseInt(state.chkPaymentGatewaySelection) === 1 && state.paymentTypeId === 2 && !state.creditCard.includes('x') && data.tripResult.length > 0) {
        let sumAmount = 0;
        let _orderDetails = '';
        for (let i = 0; i < data.tripResult.length; i++) {
          sumAmount += parseFloat(data.tripResult[i].tripFare);
          _orderDetails += (_orderDetails === '' ? '' : '') + data.tripResult[i].tripId.toString() + '_' + parseFloat(data.tripResult[i].tripFare).toFixed(2) + ',';
        }
        _orderDetails = _orderDetails.replace(/,\s*$/, '');
        const CreateTransactionRequest = {
          TransactionSource: 'UTWiz Reservation Payment',
          AccountId: Number(sessionStorage.getItem('session_accountId')),
          LocationId: Number(sessionStorage.getItem('session_locationId')),
          RideId: data.tripResult.length === 1 ? data.tripResult[0].tripId : 0,
          ReservationId: Number(data.reservationId),
          FirstName: state.paxFirstName,
          LastName: state.paxLastName,
          EmailId: state.email,
          PhoneNo: state.mobileNumber,
          Amount: parseFloat(parseFloat(sumAmount).toFixed(2)),
          OrderDetails: _orderDetails,
          PlanId: 0,
          CustomerId: parseInt(state.customer.id),
        };
        const transactionRequestParams = getRequestParams('POST', CreateTransactionRequest);
        const transactionResponse = await fetch('payment-gateway-api/' + state.chkPaymentGatewaySelection + '/transaction', transactionRequestParams);
        const transactionData = await transactionResponse.json();

        if (transactionData.transactionId != null && transactionData.settings.length >= 3) {
          const txnId = transactionData.transactionId;
          const paymentUrl = transactionData.settings[0].settingValue;
          const paymentKey = transactionData.settings[1].settingValue;
          const paymentSalt = transactionData.settings[2].settingValue;
          const dataStr = paymentKey + '|' + txnId + '|' + CreateTransactionRequest.Amount + '|UTWiz RIDE|' + state.paxFirstName + '|' + state.email + '|' + CreateTransactionRequest.TransactionSource + '|' + CreateTransactionRequest.OrderDetails + '|||||||||' + paymentSalt;
          const hashObj = new jsSHA('SHA-512', 'TEXT', { numRounds: 1 });
          hashObj.update(dataStr);
          const hashValue = hashObj.getHash('HEX');
          const paymentAppUrl = data.paymentAppUrl;
          let postForm = '<form action="' + paymentUrl + '" method="post" id="frmPay">';
          postForm += '<input type="hidden" id="key" name="key" value="' + paymentKey + '" />';
          postForm += '<input type="hidden" name="salt" value="' + paymentSalt + '" />';
          postForm += '<input type="hidden" id="firstname" name="firstname" value="' + state.paxFirstName + '" />';
          postForm += '<input type="hidden" id="lastname" name="lastname" value="' + state.paxLastName + '" />';
          postForm += '<input type="hidden" id="surl" name="surl" value="' + paymentAppUrl + 'PayUMoney/TrnxSuccess" />';
          postForm += '<input type="hidden" id="phone" name="phone" value="' + state.mobileNumber + '" />';
          postForm += '<input type="hidden" id="hash" name="hash" value="' + hashValue + '" />';
          postForm += '<input type="hidden" id="curl" name="curl" value="' + paymentAppUrl + 'PayUMoney/TrnxCancelledByUser" />';
          postForm += '<input type="hidden" id="furl" name="furl" value="' + paymentAppUrl + 'PayUMoney/TrnxFailed" />';
          postForm += '<input type="hidden" id="txnid" name="txnid" value="' + txnId + '" />';
          postForm += '<input type="hidden" id="productinfo" name="productinfo" value="UTWiz RIDE" />';
          postForm += '<input type="hidden" id="amount" name="amount" value="' + CreateTransactionRequest.Amount + '" />';
          postForm += '<input type="hidden" id="udf1" name="udf1" value="' + CreateTransactionRequest.TransactionSource + '" />';
          postForm += '<input type="hidden" id="udf2" name="udf2" value="' + CreateTransactionRequest.OrderDetails + '" />';
          postForm += '<input type="hidden" id="email" name="email" value="' + state.email + '" />';
          postForm += '<input type="submit" value="submit">';
          postForm += '</form>';
          $(postForm).appendTo('body').submit();
        }
      } else {
        let strAlert = '';
        if (!data.isSuccess) {
          strAlert = data.retValue === -2000 ? data.resultMessage : 'Reservation failed due to server error.';
        } else {
          strAlert = state.rideId <= 0 ? 'Your confirmation number is: <br><br>' : 'Your booking has been modify and updated successfully.<br><br>';
          strAlert += '\t' + data.reservationId + '<br>';
          strAlert += '<br> Thank you for booking.';
        }

        Swal.fire({ icon: data.isSuccess ? 'success' : 'error', title: data.isSuccess ? 'Success' : 'Oops...', html: strAlert, width: '25%', allowOutsideClick: false })
          .then((result) => {
            if (data.isSuccess) {
              if (result.isConfirmed) {
                props.submitFunction(false);
                if (state.rideId <= 0) {
                  if (state.isCopy) {
                    if (state.isAttachment) { const rideArray = data.tripResult.map((t) => t.tripId); props.attachmentUpload(rideArray); }
                    else if (state.isSendEmail) { props.openEmailModal(state.puDateTime, data.tripResult[0].tripId, state.email); }
                    else { props.goToBackPage(); }
                  } else {
                    if (state.isAttachment) { const rideArray = data.tripResult.map((t) => t.tripId); props.attachmentUpload(rideArray); }
                    else if (state.isSendEmail) { props.openEmailModal(state.puDateTime, data.tripResult[0].tripId, state.email); }
                    else if (state.rateLookup != null) { props.goToBackPage(); }
                    clearAllControls(setState, state.customer);
                  }
                } else {
                  if (state.isAttachment) { const rideArray = [state.rideId]; props.attachmentUpload(rideArray); }
                  else { props.goToBackPage(); }
                }
              }
            } else {
              props.submitFunction(false);
            }
          });
      }
    } catch (e) {
      props.submitFunction(false);
    }
  }, [state, setState, rideTypeIdRef, vehicleDriverRef, props]);

  const loadPage = useCallback(async (data) => {
    try {
      setState({ customer: data, airlineId: data.airlineId });
      await Promise.all([
        getAirlines(),
        getVehicleType(),
        getAffiliates(),
        getReservationModes(),
        getZones(),
        getGreeter(),
        getAgentCommission(),
        getPaymentType(),
        getVoucherCompany(),
      ]);
      getExistingCards();

      // Google autocomplete — real place_changed listeners are wired in the parent useEffect
      // We still create the Autocomplete instances here so they are attached to the DOM inputs
      if (google && google.maps) {
        const options = { types: ['establishment'] };
        const puEl = document.getElementById('pickupGoogle');
        const doEl = document.getElementById('dropoffGoogle');
        if (puEl) new google.maps.places.Autocomplete(puEl, options);
        if (doEl) new google.maps.places.Autocomplete(doEl, options);
      }

      // If editing an existing ride, populate all fields from tripDetails
      if (props.tripDetails != null) {
        isLoadingTimeRef.current = true;
        const tripDetails = props.tripDetails;
        const rideTypeIdVal = parseInt(tripDetails.rideTypeId);
        rideTypeIdRef.current = rideTypeIdVal;

        // We need dropdownZone from the current state — but getZones() already ran above.
        // Use a snapshot by calling setState functionally to read fresh zone list.
        let puZone = null;
        let doZone = null;

        setState((prev) => {
          const zones = prev.dropdownZone;
          if (rideTypeIdVal === 1) {
            puZone = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
            doZone = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
          } else if (rideTypeIdVal === 2) {
            puZone = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
            doZone = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
          } else if (rideTypeIdVal === 3) {
            puZone = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
            doZone = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
          } else {
            puZone = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
            doZone = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
          }
          return prev; // no state change here, we just need the read
        });

        const paxCount = parseInt(tripDetails.adultNo || 1);
        await getCustomerRateTaxSetting(
          puZone != null ? puZone.id : 0,
          doZone != null ? doZone.id : 0,
          new Date(tripDetails.puDateTime),
          tripDetails.apiVehicleTypeId,
          paxCount,
          0,
          tripDetails.isMgRequired,
        );

        const currentTime = sessionStorage.getItem('session_locationTime') === ''
          ? new Date()
          : new Date(sessionStorage.getItem('session_locationTime'));

        setState((prev) => {
          const zones = prev.dropdownZone;
          // Re-resolve zones from latest state
          let pu = null; let dz = null;
          if (rideTypeIdVal === 1) {
            pu = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
            dz = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
          } else if (rideTypeIdVal === 2) {
            pu = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
            dz = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
          } else if (rideTypeIdVal === 3) {
            pu = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
            dz = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
          } else {
            pu = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
            dz = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
          }

          const agentId = parseInt(tripDetails.agentId) === 0
            ? (tripDetails.agentName === ''
              ? 0
              : prev.dropdownAgentCommission.filter((opt) => opt.name === tripDetails.agentName).reduce((val, res) => { val = res.id; return val; }, 0))
            : parseInt(tripDetails.agentId);

          return {
            ...prev,
            paxFirstName: tripDetails.firstName,
            paxLastName: tripDetails.lastName,
            countryCodePhone: tripDetails.countryCode,
            phoneNumber: tripDetails.phoneNo,
            countryCode: tripDetails.cellCountryCode,
            mobileNumber: tripDetails.mobileNo,
            email: tripDetails.emailId,
            isPickupGoogleBooking: false,
            pickupLocation: tripDetails.puLocationName,
            pickupZoneId: pu != null ? pu.id : 0,
            pickupAddress: tripDetails.puAddress,
            pickupAddressType: '',
            pickupCity: tripDetails.puCity,
            pickupState: tripDetails.puStateName,
            pickupZipCode: tripDetails.puZipCode,
            pickupLatitude: tripDetails.puLatitude,
            pickupLongitude: tripDetails.puLongitude,
            isDropoffGoogleBooking: false,
            dropoffLocation: tripDetails.doLocationName,
            dropoffZoneId: dz != null ? dz.id : 0,
            dropoffAddress: tripDetails.doAddress,
            dropoffAddressType: '',
            dropoffCity: tripDetails.doCity,
            dropoffState: tripDetails.doStateName,
            dropoffZipCode: tripDetails.doZipCode,
            dropoffLatitude: tripDetails.doLatitude,
            dropoffLongitude: tripDetails.doLongitude,
            serviceSourceId: tripDetails.serviceSourceId,
            otherAffiliateId: tripDetails.serviceSourceAffiliateId,
            airlineId: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineId : tripDetails.doAirlineId,
            flightNumber: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineNo : tripDetails.doAirlineNo,
            terminalType: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puTerminalTypeId : tripDetails.doTerminalTypeId,
            terminal: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puFlightTerminal : tripDetails.doFlightTerminal,
            flightTime: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? new Date(tripDetails.puFlightDateTime) : new Date(tripDetails.doFlightDateTime),
            flightHour: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? new Date(tripDetails.puFlightDateTime).getHours() : new Date(tripDetails.doFlightDateTime).getHours(),
            flightMinute: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? new Date(tripDetails.puFlightDateTime).getMinutes() : new Date(tripDetails.doFlightDateTime).getMinutes(),
            airlineIdReturn: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineId : tripDetails.DoAirlineId,
            flightNumberReturn: '',
            terminalTypeReturn: 0,
            terminalReturn: '',
            flightTimeReturn: currentTime,
            flightHourReturn: new Date(currentTime).getHours(),
            flightMinuteReturn: new Date(currentTime).getMinutes(),
            orderByName: tripDetails.orderBy,
            countryCodeOrderPhone: tripDetails.orderByCountryCode,
            phoneNumberOrder: tripDetails.orderPhone,
            emailOrder: tripDetails.orderByEmail,
            reservationModeId: tripDetails.reservationModeId,
            puDateTime: new Date(tripDetails.puDateTime),
            puDateTimeReturn: currentTime,
            doDateTime: tripDetails.approxDropoffTime == null ? new Date() : new Date(tripDetails.approxDropoffTime),
            tripDuration: tripDetails.approxTripDurationMin,
            vehicleTypeId: tripDetails.apiVehicleTypeId,
            noOfPax: tripDetails.adultNo,
            noOfPaxReturn: 1,
            luggage: tripDetails.baggageCount,
            noOfTrip: 1,
            isAccessible: tripDetails.isAccessible,
            isVipTrip: tripDetails.vip === 'Y',
            isPriorityTrip: tripDetails.priority === 'Y',
            isMeetGreet: tripDetails.isMgRequired,
            poNumber: tripDetails.crewPo == null ? '' : tripDetails.crewPo,
            tripTypeId: '1',
            isLockRates: tripDetails.rateLocked,
            recurringTypeId: 2,
            recurringEndDate: '',
            selectedDays: [],
            isWeekSun: false, isWeekMon: false, isWeekTue: false, isWeekWed: false, isWeekThu: false, isWeekFri: false, isWeekSat: false,
            isMonthSun: false, isMonthMon: false, isMonthTue: false, isMonthWed: false, isMonthThu: false, isMonthFri: false, isMonthSat: false,
            specialInstruction: tripDetails.specialInstruction,
            permanentRemark: tripDetails.permanentRemark,
            pickupNotes: tripDetails.pickUpNotes,
            billToNotes: tripDetails.billToNotes,
            paymentTypeId: tripDetails.paymentTypeId,
            chkPaymentGatewaySelection: tripDetails.paymentGatewayId.toString(),
            voucherCompanyId: tripDetails.voucherCompany,
            paymentTermId: tripDetails.partialPay === false ? 1 : 2,
            existingCardId: 0,
            cardExpiry: '',
            cardType: '',
            cardImage: CARD_PLACEHOLDER_IMAGE,
            creditCard: '',
            checkNumber: tripDetails.chqNumber,
            checkDate: (tripDetails.chqDate !== '1900-01-01T00:00:00') ? new Date(tripDetails.chqDate) : currentTime,
            checkBank: tripDetails.chqBankName,
            chargeTo: '',
            voucherCode: tripDetails.voucherNo,
            rideAmount: tripDetails.rideAmnt,
            tollAmount: tripDetails.tollAmnt,
            tipAmount: tripDetails.tipAmnt,
            otAmount: tripDetails.ot,
            serviceFeeAmount: tripDetails.serviceFee,
            fuelSurcharge: tripDetails.fuelSurCharge,
            parkingFee: tripDetails.parking,
            tourGuideCharge: tripDetails.tourGuideCharge,
            payToTourGuide: tripDetails.payToTourGuide,
            extraAmount: tripDetails.extraAmnt,
            extraAmountFor: tripDetails.extraAmntFor,
            waitingCharge: tripDetails.wt,
            waitingTime: tripDetails.wtTime,
            waitingChargeTotal: tripDetails.wtTotal,
            extraStopCharge: tripDetails.stop,
            noOfStops: tripDetails.noOfStop,
            stopTotal: tripDetails.noOfStop * tripDetails.stop,
            meetGreet: tripDetails.meetGreetCharge,
            mgToPay: tripDetails.mgPayTo.toString(),
            payMeetGreetId: tripDetails.meetGreetId,
            payMeetGreetAmount: tripDetails.meetGreetAmount,
            mgDriverComms: tripDetails.mgDriverComms === false ? '1' : '2',
            agentCommissionId: agentId,
            agentCommissionName: tripDetails.agentName,
            agentCommissionAmount: tripDetails.agentCommission,
            discount: tripDetails.affDiscount,
            portAuthority: tripDetails.portAuthority,
            utitity: tripDetails.utilityTax,
            countyTax: tripDetails.countyTax,
            congestionTax: tripDetails.congestionTax,
            workCompantation: tripDetails.wcTax,
            salesTax: tripDetails.salesTax,
            grossAmount: tripDetails.affGross,
            totalFare: tripDetails.affTotalFare,
            paidAmount: tripDetails.affTotalPaid,
          };
        });

        // Set vehicle/driver on the VehicleDriverComponent ref
        if (vehicleDriverRef.current) {
          vehicleDriverRef.current.state.filterVehicleId = tripDetails.vehicleId;
          vehicleDriverRef.current.state.filterDriverId = tripDetails.driverId;
        }

        // Handle saved credit card
        if (parseInt(tripDetails.paymentGatewayId) === 2) {
          if (parseInt(tripDetails.paymentTypeId) === 2) {
            setState({ creditCard: 'xxxxxxxxxxxx' + tripDetails.ccNumber, cardExpiry: tripDetails.ccExp, cardType: tripDetails.ccType, isLockRates: true });
            CardTypes.forEach((item) => {
              if (tripDetails.ccType.trim().match(item.name)) setState({ cardImage: item.image });
            });
          }
        } else if (parseInt(tripDetails.paymentTypeId) === 2) {
          setState({ creditCard: 'xxxxxxxxxxxx' + tripDetails.ccNumber, isLockRates: true });
        }

        isLoadingTimeRef.current = false;
      }

      // If invoked from rate lookup (quick-book), pre-fill zone/vehicle
      if (state.rateLookup != null) {
        setState({
          pickupZoneId: state.rateLookup.FromZoneId,
          dropoffZoneId: state.rateLookup.ToZoneId,
          vehicleTypeId: state.rateLookup.ApiVehicleTypeId,
          isMeetGreet: state.rateLookup.IsMgRequired,
        });
        getRideTypeId(state.rateLookup.FromZoneId, state.rateLookup.ToZoneId);
        getCustomerRateTaxSetting(state.rateLookup.FromZoneId, state.rateLookup.ToZoneId, state.puDateTime, state.rateLookup.ApiVehicleTypeId, parseInt(state.noOfPax | 0), 0, state.rateLookup.IsMgRequired);
      }
    } catch (ex) {
      console.log(ex);
    }
  }, [getAirlines, getVehicleType, getAffiliates, getReservationModes, getZones, getGreeter, getAgentCommission, getPaymentType, getVoucherCompany, getExistingCards, getCustomerRateTaxSetting, getRideTypeId, setState, rideTypeIdRef, isLoadingTimeRef, vehicleDriverRef, props, state.rateLookup, state.puDateTime, state.noOfPax]);

  const copyReservation = useCallback(async () => {
    try {
      if (props.tripDetails == null) return;

      isLoadingTimeRef.current = true;
      setState({ loadPanelVisible: true });

      const tripDetails = props.tripDetails;
      const rideTypeIdVal = parseInt(tripDetails.rideTypeId);
      rideTypeIdRef.current = rideTypeIdVal;

      let puZone = null;
      let doZone = null;
      setState((prev) => {
        const zones = prev.dropdownZone;
        if (rideTypeIdVal === 1) {
          puZone = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
          doZone = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
        } else if (rideTypeIdVal === 2) {
          puZone = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
          doZone = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
        } else if (rideTypeIdVal === 3) {
          puZone = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
          doZone = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
        } else {
          puZone = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
          doZone = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
        }
        return prev;
      });

      const currentTime = sessionStorage.getItem('session_locationTime') === ''
        ? new Date()
        : new Date(sessionStorage.getItem('session_locationTime'));
      const currentHour = new Date(currentTime).getHours();
      const currentMinute = new Date(currentTime).getMinutes();

      const paxCount = parseInt(state.noOfPax | 0);
      await getCustomerRateTaxSetting(
        puZone != null ? puZone.id : 0,
        doZone != null ? doZone.id : 0,
        currentTime,
        tripDetails.apiVehicleTypeId,
        paxCount,
        0,
        tripDetails.isMgRequired,
      );

      setState((prev) => {
        const zones = prev.dropdownZone;
        let pu = null; let dz = null;
        if (rideTypeIdVal === 1) {
          pu = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
          dz = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
        } else if (rideTypeIdVal === 2) {
          pu = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
          dz = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
        } else if (rideTypeIdVal === 3) {
          pu = zones.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
          dz = zones.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
        } else {
          pu = zones.find((opt) => opt.id === tripDetails.puAreaId) || null;
          dz = zones.find((opt) => opt.id === tripDetails.doAreaId) || null;
        }

        const agentId = parseInt(tripDetails.agentId) === 0
          ? prev.dropdownAgentCommission.filter((opt) => opt.name === tripDetails.agentName).reduce((val, res) => { val = res.id; return val; }, 0)
          : parseInt(tripDetails.agentId);

        return {
          ...prev,
          isCopy: true,
          rideId: 0,
          paxFirstName: tripDetails.firstName,
          paxLastName: tripDetails.lastName,
          countryCodePhone: tripDetails.countryCode,
          phoneNumber: tripDetails.phoneNo,
          countryCode: tripDetails.cellCountryCode,
          mobileNumber: tripDetails.mobileNo,
          email: tripDetails.emailId,
          isPickupGoogleBooking: false,
          pickupLocation: tripDetails.puLocationName,
          pickupZoneId: pu != null ? pu.id : 0,
          pickupAddress: tripDetails.puAddress,
          pickupAddressType: '',
          pickupCity: tripDetails.puCity,
          pickupState: tripDetails.puStateName,
          pickupZipCode: tripDetails.puZipCode,
          pickupLatitude: tripDetails.puLatitude,
          pickupLongitude: tripDetails.puLongitude,
          isDropoffGoogleBooking: false,
          dropoffLocation: tripDetails.doLocationName,
          dropoffZoneId: dz != null ? dz.id : 0,
          dropoffAddress: tripDetails.doAddress,
          dropoffAddressType: '',
          dropoffCity: tripDetails.doCity,
          dropoffState: tripDetails.doStateName,
          dropoffZipCode: tripDetails.doZipCode,
          dropoffLatitude: tripDetails.doLatitude,
          dropoffLongitude: tripDetails.doLongitude,
          serviceSourceId: tripDetails.serviceSourceId,
          otherAffiliateId: tripDetails.serviceSourceAffiliateId,
          airlineId: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineId : tripDetails.doAirlineId,
          flightNumber: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineNo : tripDetails.doAirlineNo,
          terminalType: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puTerminalTypeId : tripDetails.doTerminalTypeId,
          terminal: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puFlightTerminal : tripDetails.doFlightTerminal,
          flightTime: currentTime,
          flightHour: currentHour,
          flightMinute: currentMinute,
          airlineIdReturn: (rideTypeIdVal === 1 || rideTypeIdVal === 3) ? tripDetails.puAirlineId : tripDetails.DoAirlineId,
          flightNumberReturn: '',
          terminalTypeReturn: 0,
          terminalReturn: '',
          flightTimeReturn: currentTime,
          flightHourReturn: currentHour,
          flightMinuteReturn: currentMinute,
          orderByName: tripDetails.orderBy,
          countryCodeOrderPhone: tripDetails.orderByCountryCode,
          phoneNumberOrder: tripDetails.orderPhone,
          emailOrder: tripDetails.orderByEmail,
          reservationModeId: tripDetails.reservationModeId,
          puDateTime: currentTime,
          puDateTimeReturn: currentTime,
          doDateTime: currentTime,
          tripDuration: tripDetails.approxTripDurationMin,
          vehicleTypeId: tripDetails.apiVehicleTypeId,
          noOfPax: tripDetails.adultNo,
          noOfPaxReturn: 1,
          luggage: tripDetails.baggageCount,
          noOfTrip: 1,
          isAccessible: tripDetails.isAccessible,
          isVipTrip: tripDetails.vip === 'Y',
          isPriorityTrip: tripDetails.priority === 'Y',
          isMeetGreet: tripDetails.isMgRequired,
          poNumber: tripDetails.crewPo == null ? '' : tripDetails.crewPo,
          tripTypeId: '1',
          isLockRates: tripDetails.rateLocked,
          recurringTypeId: 2,
          recurringEndDate: '',
          selectedDays: [],
          isWeekSun: false, isWeekMon: false, isWeekTue: false, isWeekWed: false, isWeekThu: false, isWeekFri: false, isWeekSat: false,
          isMonthSun: false, isMonthMon: false, isMonthTue: false, isMonthWed: false, isMonthThu: false, isMonthFri: false, isMonthSat: false,
          specialInstruction: tripDetails.specialInstruction,
          permanentRemark: tripDetails.permanentRemark,
          pickupNotes: tripDetails.pickUpNotes,
          billToNotes: tripDetails.billToNotes,
          paymentTypeId: 1,
          voucherCompanyId: 0,
          paymentTermId: 1,
          existingCardId: 0,
          cardExpiry: '',
          cardType: '',
          cardImage: CARD_PLACEHOLDER_IMAGE,
          creditCard: '',
          checkNumber: '',
          checkDate: currentTime,
          checkBank: '',
          chargeTo: '',
          voucherCode: '',
          chkPaymentGatewaySelection: '1',
          rideAmount: tripDetails.rideAmnt,
          tollAmount: tripDetails.tollAmnt,
          tipAmount: tripDetails.tipAmnt,
          otAmount: tripDetails.ot,
          serviceFeeAmount: tripDetails.serviceFee,
          fuelSurcharge: tripDetails.fuelSurCharge,
          parkingFee: tripDetails.parking,
          tourGuideCharge: tripDetails.tourGuideCharge,
          payToTourGuide: tripDetails.payToTourGuide,
          extraAmount: tripDetails.extraAmnt,
          extraAmountFor: tripDetails.extraAmntFor,
          waitingCharge: tripDetails.wt,
          waitingTime: tripDetails.wtTime,
          waitingChargeTotal: tripDetails.wtTotal,
          extraStopCharge: tripDetails.stop,
          noOfStops: tripDetails.noOfStop,
          stopTotal: tripDetails.noOfStop * tripDetails.stop,
          meetGreet: tripDetails.meetGreetCharge,
          mgToPay: tripDetails.mgPayTo.toString(),
          payMeetGreetId: tripDetails.meetGreetId,
          payMeetGreetAmount: tripDetails.meetGreetAmount,
          mgDriverComms: tripDetails.mgDriverComms === false ? '1' : '2',
          agentCommissionId: agentId,
          agentCommissionName: tripDetails.agentName,
          agentCommissionAmount: tripDetails.agentCommission,
          discount: tripDetails.affDiscount,
          portAuthority: tripDetails.portAuthority,
          utitity: tripDetails.utilityTax,
          countyTax: tripDetails.countyTax,
          congestionTax: tripDetails.congestionTax,
          workCompantation: tripDetails.wcTax,
          salesTax: tripDetails.salesTax,
          grossAmount: tripDetails.affGross,
          totalFare: tripDetails.affTotalFare,
          paidAmount: tripDetails.affTotalPaid,
        };
      });

      // Reset vehicle/driver assignment (copy = new booking, no vehicle pre-assigned)
      if (vehicleDriverRef.current) {
        vehicleDriverRef.current.state.filterVehicleId = 0;
        vehicleDriverRef.current.state.filterDriverId = 0;
      }

      setState({ loadPanelVisible: false });

      await Swal.fire({
        title: '<small>Copy Reservation</small>',
        text: 'Reservation copied successfully.',
        icon: 'success',
        width: '25%',
        dangerMode: false,
        allowOutsideClick: false,
      });

      isLoadingTimeRef.current = false;
    } catch (ex) {
      console.log(ex);
    }
  }, [state.noOfPax, getCustomerRateTaxSetting, vehicleDriverRef, rideTypeIdRef, isLoadingTimeRef, setState, props]);

  return {
    loadPage,
    copyReservation,
    getAirlines,
    getVehicleType,
    getAffiliates,
    getReservationModes,
    getZones,
    getGreeter,
    getAgentCommission,
    getPaymentType,
    getVoucherCompany,
    getExistingCards,
    getRideTypeId,
    getCustomerRateTaxSetting,
    calculateFare,
    fillRateControls,
    getBookingSuggestions,
    checkDuplicateReservation,
    bookReservation,
    isLoadingTimeRef,
  };
}

// Helper: recurring date array (pure, uses state snapshot)
function getRecurringPuDateArrayList(state) {
  if (state.recurringTypeId == 1) return getDailyRecurringDays(state);
  if (state.recurringTypeId == 2) return getWeeklyRecurringDays(state);
  if (state.recurringTypeId == 3) return getMonthlyRecurringDays(state);
  return [];
}

function diffDays(d1, d2) {
  const ndays = (d2.valueOf() - d1.valueOf()) / 1000 / 86400;
  return Math.round(ndays - 0.5);
}

function getDailyRecurringDays(state) {
  const finalArrayList = [];
  let stpuDate = new Date(new Date(state.puDateTime).toLocaleDateString());
  const enDate = new Date(new Date(state.recurringEndDate).toLocaleDateString());
  const dayscount = diffDays(stpuDate, enDate) + 1;
  const chkPuDay = state.selectedDays.map((d) => d.toLocaleDateString());
  for (let day = 1; day <= dayscount; day++) {
    if (chkPuDay.includes(stpuDate.toLocaleDateString())) {
      finalArrayList.push(((stpuDate.getMonth() + 1) < 10 ? '0' + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? '0' + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
    }
    stpuDate.setDate(stpuDate.getDate() + 1);
  }
  return finalArrayList;
}

function getWeeklyRecurringDays(state) {
  const finalArrayList = [];
  let stpuDate = new Date(new Date(state.puDateTime).toLocaleDateString());
  const enDate = new Date(new Date(state.recurringEndDate).toLocaleDateString());
  const dayscount = diffDays(stpuDate, enDate) + 1;
  const chkPuDay = [];
  if (state.isWeekMon) chkPuDay.push(1);
  if (state.isWeekTue) chkPuDay.push(2);
  if (state.isWeekWed) chkPuDay.push(3);
  if (state.isWeekThu) chkPuDay.push(4);
  if (state.isWeekFri) chkPuDay.push(5);
  if (state.isWeekSat) chkPuDay.push(6);
  if (state.isWeekSun) chkPuDay.push(0);
  for (let day = 1; day <= dayscount; day++) {
    if (chkPuDay.includes(stpuDate.getDay())) {
      finalArrayList.push(((stpuDate.getMonth() + 1) < 10 ? '0' + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? '0' + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
    }
    stpuDate.setDate(stpuDate.getDate() + 1);
  }
  return finalArrayList;
}

function getMonthlyRecurringDays(state) {
  const finalArrayList = [];
  let stpuDate = new Date(new Date(state.puDateTime).toLocaleDateString());
  const enDate = new Date(new Date(state.recurringEndDate).toLocaleDateString());
  const dayscount = diffDays(stpuDate, enDate) + 1;
  const chkPuMonths = [];
  if (state.isMonthMon) chkPuMonths.push(1);
  if (state.isMonthTue) chkPuMonths.push(2);
  if (state.isMonthWed) chkPuMonths.push(3);
  if (state.isMonthThu) chkPuMonths.push(4);
  if (state.isMonthFri) chkPuMonths.push(5);
  if (state.isMonthSat) chkPuMonths.push(6);
  if (state.isMonthSun) chkPuMonths.push(0);
  for (let day = 1; day <= dayscount; day++) {
    if (chkPuMonths.includes(stpuDate.getDay())) {
      finalArrayList.push(((stpuDate.getMonth() + 1) < 10 ? '0' + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? '0' + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
    }
    stpuDate.setDate(stpuDate.getDate() + 1);
  }
  return finalArrayList;
}

// Pure helper: build a string log of what changed vs. original tripDetails (edit flow)
function getTripChangesDetails(state, props, rideTypeIdRef) {
  if (props.tripDetails == null) return '';

  const tripDetails = props.tripDetails;
  let changes = '';
  const rideTypeIdOld = parseInt(tripDetails.rideTypeId);
  const rideTypeIdCurrent = rideTypeIdRef.current;

  let puZone = null;
  let doZone = null;
  if (rideTypeIdOld === 1) {
    puZone = state.dropdownZone.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
    doZone = state.dropdownZone.find((opt) => opt.id === tripDetails.doAreaId) || null;
  } else if (rideTypeIdOld === 2) {
    puZone = state.dropdownZone.find((opt) => opt.id === tripDetails.puAreaId) || null;
    doZone = state.dropdownZone.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
  } else if (rideTypeIdOld === 3) {
    puZone = state.dropdownZone.find((opt) => opt.airportId === tripDetails.puAreaId) || null;
    doZone = state.dropdownZone.find((opt) => opt.airportId === tripDetails.doAreaId) || null;
  } else {
    puZone = state.dropdownZone.find((opt) => opt.id === tripDetails.puAreaId) || null;
    doZone = state.dropdownZone.find((opt) => opt.id === tripDetails.doAreaId) || null;
  }

  if (state.paxFirstName !== tripDetails.firstName) changes += 'Pax first name changed from ' + tripDetails.firstName + ' to ' + state.paxFirstName + '. ';
  if (state.paxLastName !== tripDetails.lastName) changes += 'Pax last name changed from ' + tripDetails.lastName + ' to ' + state.paxLastName + '. ';
  if (state.countryCodePhone !== tripDetails.countryCode) changes += 'Country code changed from ' + tripDetails.countryCode + ' to ' + state.countryCodePhone + '. ';
  if (state.phoneNumber !== tripDetails.phoneNo) changes += 'Phone no changed from ' + tripDetails.phoneNo + ' to ' + state.phoneNumber + '. ';
  if (state.countryCode !== tripDetails.cellCountryCode) changes += 'Cell country code changed from ' + tripDetails.cellCountryCode + ' to ' + state.countryCode + '. ';
  if (state.mobileNumber !== tripDetails.mobileNo) changes += 'Mobile number changed from ' + tripDetails.mobileNo + ' to ' + state.mobileNumber + '. ';
  if (state.email !== tripDetails.emailId) changes += 'Email changed from ' + tripDetails.emailId + ' to ' + state.email + '. ';
  if (state.poNumber !== tripDetails.crewPo) changes += 'PO changed from ' + tripDetails.crewPo + ' to ' + state.poNumber + '. ';

  if (state.pickupLocation !== tripDetails.puLocationName) changes += 'Pickup location changed from ' + tripDetails.puLocationName + ' to ' + state.pickupLocation + '. ';
  if (parseInt(state.pickupZoneId) !== parseInt(puZone != null ? puZone.id : 0)) {
    const puZoneNew = state.dropdownZone.find((opt) => opt.id === parseInt(state.pickupZoneId));
    changes += 'Pickup zone changed from ' + (puZone != null ? puZone.name : '') + ' to ' + (puZoneNew ? puZoneNew.name : '') + '. ';
  }
  if (state.pickupAddress !== tripDetails.puAddress) changes += 'Pickup address changed from ' + tripDetails.puAddress + ' to ' + state.pickupAddress + '. ';

  if (state.dropoffLocation !== tripDetails.doLocationName) changes += 'Dropoff location changed from ' + tripDetails.doLocationName + ' to ' + state.dropoffLocation + '. ';
  if (parseInt(state.dropoffZoneId) !== parseInt(doZone != null ? doZone.id : 0)) {
    const doZoneNew = state.dropdownZone.find((opt) => opt.id === parseInt(state.dropoffZoneId));
    changes += 'Dropoff zone changed from ' + (doZone != null ? doZone.name : '') + ' to ' + (doZoneNew ? doZoneNew.name : '') + '. ';
  }
  if (state.dropoffAddress !== tripDetails.doAddress) changes += 'Dropoff address changed from ' + tripDetails.doAddress + ' to ' + state.dropoffAddress + '. ';

  if (parseInt(state.serviceSourceId) !== parseInt(tripDetails.serviceSourceId)) {
    const newSource = parseInt(state.serviceSourceId) === 1 ? 'In House' : (parseInt(state.serviceSourceId) === 2 ? 'Farm In' : 'Farm Out');
    const oldSource = parseInt(tripDetails.serviceSourceId) === 1 ? 'In House' : (parseInt(tripDetails.serviceSourceId) === 2 ? 'Farm In' : 'Farm Out');
    changes += 'Service source changed from ' + oldSource + ' to ' + newSource + '. ';
  }

  if (parseInt(state.otherAffiliateId) !== parseInt(tripDetails.serviceSourceAffiliateId)) {
    if (parseInt(state.otherAffiliateId) > 0 && parseInt(tripDetails.serviceSourceAffiliateId) === 0) {
      const newSource = state.dropdownAffiliates.find((opt) => opt.id === parseInt(state.otherAffiliateId));
      changes += 'Source affiliate added ' + (newSource ? newSource.name : '') + '. ';
    } else if (parseInt(state.otherAffiliateId) === 0 && parseInt(tripDetails.serviceSourceAffiliateId) > 0) {
      const oldSource = state.dropdownAffiliates.find((opt) => opt.id === parseInt(tripDetails.serviceSourceAffiliateId));
      changes += 'Source affiliate removed ' + (oldSource ? oldSource.name : '') + '. ';
    } else {
      const newSource = state.dropdownAffiliates.find((opt) => opt.id === parseInt(state.otherAffiliateId));
      const oldSource = state.dropdownAffiliates.find((opt) => opt.id === parseInt(tripDetails.serviceSourceAffiliateId));
      changes += 'Source affiliate changed from ' + (oldSource ? oldSource.name : '') + ' to ' + (newSource ? newSource.name : '') + '. ';
    }
  }

  const airlineIdOld = parseInt((rideTypeIdCurrent === 1 || rideTypeIdCurrent === 3) ? tripDetails.puAirlineId : tripDetails.doAirlineId);
  if (parseInt(state.airlineId) !== airlineIdOld) {
    if (parseInt(state.airlineId) > 0 && airlineIdOld === 0) {
      const newAirline = state.dropdownAirline.find((opt) => opt.airLineId === parseInt(state.airlineId));
      changes += 'Airline added ' + (newAirline ? newAirline.airLineName : '') + '. ';
    } else if (parseInt(state.airlineId) === 0 && airlineIdOld > 0) {
      const oldAirline = state.dropdownAirline.find((opt) => opt.airLineId === airlineIdOld);
      changes += 'Airline removed ' + (oldAirline ? oldAirline.airLineName : '') + '. ';
    } else {
      const newAirline = state.dropdownAirline.find((opt) => opt.airLineId === parseInt(state.airlineId));
      const oldAirline = state.dropdownAirline.find((opt) => opt.airLineId === airlineIdOld);
      changes += 'Airline changed from ' + (oldAirline ? oldAirline.airLineName : '') + ' to ' + (newAirline ? newAirline.airLineName : '') + '. ';
    }
  }

  const flightNoOld = (rideTypeIdOld === 1 || rideTypeIdOld === 3) ? tripDetails.puAirlineNo : tripDetails.doAirlineNo;
  if (state.flightNumber !== flightNoOld) changes += 'Flight number changed from ' + flightNoOld + ' to ' + state.flightNumber + '. ';

  const terminalOld = (rideTypeIdOld === 1 || rideTypeIdOld === 3) ? tripDetails.puFlightTerminal : tripDetails.doFlightTerminal;
  if (state.terminal !== terminalOld) changes += 'Terminal changed from ' + terminalOld + ' to ' + state.terminal + '. ';

  const terminalTypeOld = parseInt((rideTypeIdOld === 1 || rideTypeIdOld === 3) ? tripDetails.puTerminalTypeId : tripDetails.doTerminalTypeId);
  if (parseInt(state.terminalType) !== terminalTypeOld) {
    if (parseInt(state.terminalType) > 0 && terminalTypeOld === 0) {
      const newT = terminalTypeData.find((opt) => opt.id === parseInt(state.terminalType));
      changes += 'Terminal type added ' + (newT ? newT.name : '') + '. ';
    } else if (parseInt(state.terminalType) === 0 && terminalTypeOld > 0) {
      const oldT = terminalTypeData.find((opt) => opt.id === terminalTypeOld);
      changes += 'Terminal type removed ' + (oldT ? oldT.name : '') + '. ';
    } else {
      const newT = terminalTypeData.find((opt) => opt.id === parseInt(state.terminalType));
      const oldT = terminalTypeData.find((opt) => opt.id === terminalTypeOld);
      changes += 'Terminal type changed from ' + (oldT ? oldT.name : '') + ' to ' + (newT ? newT.name : '') + '. ';
    }
  }

  const flightDateOld = (rideTypeIdOld === 1 || rideTypeIdOld === 3) ? new Date(tripDetails.puFlightDateTime) : new Date(tripDetails.doFlightDateTime);
  const flightTimeNew = state.puDateTime.toLocaleDateString() + ' ' + new Date(state.flightTime).toLocaleTimeString();
  const flightTimeOld = flightDateOld.toLocaleDateString() + ' ' + flightDateOld.toLocaleTimeString();
  if (flightTimeNew !== flightTimeOld) changes += 'Flight date changed from ' + flightTimeOld + ' to ' + flightTimeNew + '. ';

  if (state.orderByName !== tripDetails.orderBy) changes += 'Order by changed from ' + tripDetails.orderBy + ' to ' + state.orderByName + '. ';
  if (state.countryCodeOrderPhone !== tripDetails.orderByCountryCode) changes += 'Order by country code changed from ' + tripDetails.orderByCountryCode + ' to ' + state.countryCodeOrderPhone + '. ';
  if (state.phoneNumberOrder !== tripDetails.orderPhone) changes += 'Order by phone no changed from ' + tripDetails.orderPhone + ' to ' + state.phoneNumberOrder + '. ';
  if (state.emailOrder !== tripDetails.orderByEmail) changes += 'Order by email changed from ' + tripDetails.orderByEmail + ' to ' + state.emailOrder + '. ';

  if (parseInt(state.reservationModeId) !== parseInt(tripDetails.reservationModeId)) {
    const newMode = state.dropdownReservationMode.find((opt) => opt.id === parseInt(state.reservationModeId));
    const oldMode = state.dropdownReservationMode.find((opt) => opt.id === parseInt(tripDetails.reservationModeId));
    changes += 'Reservation mode changed from ' + (oldMode ? oldMode.name : '') + ' to ' + (newMode ? newMode.name : '') + '. ';
  }

  const puDateNew = state.puDateTime.toLocaleDateString() + ' ' + state.puDateTime.toLocaleTimeString();
  const puDateOld = new Date(tripDetails.puDateTime).toLocaleDateString() + ' ' + new Date(tripDetails.puDateTime).toLocaleTimeString();
  if (puDateNew !== puDateOld) changes += 'Pickup date changed from ' + puDateOld + ' to ' + puDateNew + '. ';

  if (parseInt(state.vehicleTypeId) !== parseInt(tripDetails.apiVehicleTypeId)) {
    const newVT = state.dropdownVehicleType.find((opt) => opt.rowIndex === parseInt(state.vehicleTypeId));
    const oldVT = state.dropdownVehicleType.find((opt) => opt.rowIndex === parseInt(tripDetails.apiVehicleTypeId));
    changes += 'Vehicle type changed from ' + (oldVT ? oldVT.apiVehicleTypeDescription : '') + ' to ' + (newVT ? newVT.apiVehicleTypeDescription : '') + '. ';
  }
  if (parseInt(state.noOfPax) !== parseInt(tripDetails.adultNo)) changes += 'Pax count changed from ' + tripDetails.adultNo + ' to ' + state.noOfPax + '. ';
  if (parseInt(state.luggage) !== parseInt(tripDetails.baggageCount)) changes += 'Luggage count changed from ' + tripDetails.baggageCount + ' to ' + state.luggage + '. ';

  if (state.isAccessible !== tripDetails.isAccessible) changes += 'Accessible changed from ' + (state.isAccessible ? 'NO to YES' : 'YES to NO') + '. ';
  if (state.isVipTrip !== (tripDetails.vip === 'Y')) changes += 'VIP changed from ' + (state.isVipTrip ? 'NO to YES' : 'YES to NO') + '. ';
  if (state.isPriorityTrip !== (tripDetails.priority === 'Y')) changes += 'Priority changed from ' + (state.isPriorityTrip ? 'NO to YES' : 'YES to NO') + '. ';
  if (state.isMeetGreet !== tripDetails.isMgRequired) changes += 'MeetGreet changed from ' + (state.isMeetGreet ? 'NO to YES' : 'YES to NO') + '. ';
  if (state.isLockRates !== tripDetails.rateLocked) changes += 'Lock rate changed from ' + (state.isLockRates ? 'NO to YES' : 'YES to NO') + '. ';

  if (state.specialInstruction !== tripDetails.specialInstruction) changes += 'Spl. inst. changed from ' + tripDetails.specialInstruction + ' to ' + state.specialInstruction + '. ';
  if (state.permanentRemark !== tripDetails.permanentRemark) changes += 'Permanent remark changed from ' + tripDetails.permanentRemark + ' to ' + state.permanentRemark + '. ';
  if (state.pickupNotes !== tripDetails.pickUpNotes) changes += 'Pick-up notes changed from ' + tripDetails.pickUpNotes + ' to ' + state.pickupNotes + '. ';
  if (state.billToNotes !== tripDetails.billToNotes) changes += 'Bill notes changed from ' + tripDetails.billToNotes + ' to ' + state.billToNotes + '. ';

  if (parseInt(state.paymentTypeId) !== parseInt(tripDetails.paymentTypeId)) {
    const newPT = state.dropdownPaymentType.find((opt) => opt.id === parseInt(state.paymentTypeId));
    const oldPT = state.dropdownPaymentType.find((opt) => opt.id === parseInt(tripDetails.paymentTypeId));
    changes += 'Payment type changed from ' + (oldPT ? oldPT.name : '') + ' to ' + (newPT ? newPT.name : '') + '. ';
  }
  if (parseInt(state.paymentTermId) !== parseInt(tripDetails.partialPay === false ? 1 : 2)) {
    changes += state.paymentTermId === 2 ? 'Partial payment applied. ' : 'Paid in full. ';
  }

  if (parseFloat(state.rideAmount) !== parseFloat(tripDetails.rideAmnt)) changes += 'Ride amount changed from ' + tripDetails.rideAmnt + ' to ' + state.rideAmount + '. ';
  if (parseFloat(state.tollAmount) !== parseFloat(tripDetails.tollAmnt)) changes += 'Toll amount changed from ' + tripDetails.tollAmnt + ' to ' + state.tollAmount + '. ';
  if (parseFloat(state.tipAmount) !== parseFloat(tripDetails.tipAmnt)) changes += 'Tip amount changed from ' + tripDetails.tipAmnt + ' to ' + state.tipAmount + '. ';
  if (parseFloat(state.otAmount) !== parseFloat(tripDetails.ot)) changes += 'OT amount changed from ' + tripDetails.ot + ' to ' + state.otAmount + '. ';
  if (parseFloat(state.serviceFeeAmount) !== parseFloat(tripDetails.serviceFee)) changes += 'Service fee changed from ' + tripDetails.serviceFee + ' to ' + state.serviceFeeAmount + '. ';
  if (parseFloat(state.fuelSurcharge) !== parseFloat(tripDetails.fuelSurCharge)) changes += 'Fuel surcharge changed from ' + tripDetails.fuelSurCharge + ' to ' + state.fuelSurcharge + '. ';
  if (parseFloat(state.parkingFee) !== parseFloat(tripDetails.parking)) changes += 'Parking changed from ' + tripDetails.parking + ' to ' + state.parkingFee + '. ';
  if (parseFloat(state.tourGuideCharge) !== parseFloat(tripDetails.tourGuideCharge)) changes += 'Tour guide charge changed from ' + tripDetails.tourGuideCharge + ' to ' + state.tourGuideCharge + '. ';
  if (parseFloat(state.payToTourGuide) !== parseFloat(tripDetails.payToTourGuide)) changes += 'Pay to tour guide changed from ' + tripDetails.payToTourGuide + ' to ' + state.payToTourGuide + '. ';
  if (parseFloat(state.extraAmount) !== parseFloat(tripDetails.extraAmnt)) changes += 'Extra amount changed from ' + tripDetails.extraAmnt + ' to ' + state.extraAmount + '. ';
  if (parseFloat(state.waitingCharge) !== parseFloat(tripDetails.wt)) changes += 'Waiting charge changed from ' + tripDetails.wt + ' to ' + state.waitingCharge + '. ';
  if (parseInt(state.waitingTime) !== parseInt(tripDetails.wtTime)) changes += 'Waiting time changed from ' + tripDetails.wtTime + ' to ' + state.waitingTime + '. ';
  if (parseFloat(state.extraStopCharge) !== parseFloat(tripDetails.stop)) changes += 'Stop charge changed from ' + tripDetails.stop + ' to ' + state.extraStopCharge + '. ';
  if (parseInt(state.noOfStops) !== parseInt(tripDetails.noOfStop)) changes += 'No of stops changed from ' + tripDetails.noOfStop + ' to ' + state.noOfStops + '. ';
  if (parseFloat(state.meetGreet) !== parseFloat(tripDetails.meetGreetCharge)) changes += 'Meet & greet charge changed from ' + tripDetails.meetGreetCharge + ' to ' + state.meetGreet + '. ';

  if (state.mgToPay !== tripDetails.mgPayTo.toString()) {
    const payLabel = (id) => id === 1 ? 'Pay To Greeter' : (id === 2 ? '100% to Company' : 'Pay to Driver');
    changes += 'Meet & greet payment type changed from ' + payLabel(parseInt(tripDetails.mgPayTo)) + ' to ' + payLabel(parseInt(state.mgToPay)) + '. ';
  }
  if (parseFloat(state.payMeetGreetAmount) !== parseFloat(tripDetails.meetGreetAmount)) changes += 'Meet & greet amount changed from ' + tripDetails.meetGreetAmount + ' to ' + state.payMeetGreetAmount + '. ';
  if (state.mgDriverComms !== (tripDetails.mgDriverComms === false ? '1' : '2')) {
    const newDC = parseInt(state.mgDriverComms) === 1 ? 'PayToDriver 100%' : 'PayToDriver Split';
    const oldDC = tripDetails.mgDriverComms === false ? 'PayToDriver 100%' : 'PayToDriver Split';
    changes += 'Driver comm type changed from ' + oldDC + ' to ' + newDC + '. ';
  }

  if (state.agentCommissionName !== tripDetails.agentName) changes += 'Agent changed from ' + tripDetails.agentName + ' to ' + state.agentCommissionName + '. ';
  if (parseFloat(state.agentCommissionAmount) !== parseFloat(tripDetails.agentCommission)) changes += 'Agent commission changed from ' + tripDetails.agentCommission + ' to ' + state.agentCommissionAmount + '. ';
  if (parseFloat(state.discount) !== parseFloat(tripDetails.affDiscount)) changes += 'Discount changed from ' + tripDetails.affDiscount + ' to ' + state.discount + '. ';
  if (parseFloat(state.totalFare) !== parseFloat(tripDetails.affTotalFare)) changes += 'Total fare changed from ' + tripDetails.affTotalFare + ' to ' + state.totalFare + '. ';

  return changes === '' ? 'Ride updated without any changes.' : changes;
}

function clearAllControls(setState, customer) {
  const currentTime = sessionStorage.getItem('session_locationTime') === ''
    ? new Date()
    : new Date(sessionStorage.getItem('session_locationTime'));
  const currentHour = new Date(currentTime).getHours();
  const currentMinute = new Date(currentTime).getMinutes();

  setState({
    rideId: 0,
    paxFirstName: '',
    paxLastName: '',
    countryCodePhone: '1',
    phoneNumber: '',
    countryCode: '1',
    mobileNumber: '',
    email: '',
    isSendEmail: false,
    poNumber: '',
    isPickupGoogleBooking: false,
    pickupLocation: '',
    pickupZoneId: 0,
    pickupAddress: '',
    pickupAddressType: '',
    pickupCity: '',
    pickupState: '',
    pickupZipCode: '',
    pickupLatitude: 0,
    pickupLongitude: 0,
    isDropoffGoogleBooking: false,
    dropoffLocation: '',
    dropoffZoneId: 0,
    dropoffAddress: '',
    dropoffAddressType: '',
    dropoffCity: '',
    dropoffState: '',
    dropoffZipCode: '',
    dropoffLatitude: 0,
    dropoffLongitude: 0,
    serviceSourceId: 1,
    otherAffiliateId: 0,
    airlineId: customer ? customer.airlineId : 0,
    flightNumber: '',
    terminalType: 0,
    terminal: '',
    flightTime: currentTime,
    flightHour: currentHour,
    flightMinute: currentMinute,
    airlineIdReturn: customer ? customer.airlineId : 0,
    flightNumberReturn: '',
    terminalTypeReturn: 0,
    terminalReturn: '',
    flightTimeReturn: currentTime,
    flightHourReturn: currentHour,
    flightMinuteReturn: currentMinute,
    orderByName: '',
    countryCodeOrderPhone: '',
    phoneNumberOrder: '',
    emailOrder: '',
    reservationModeId: 0,
    puDateTime: currentTime,
    puDateTimeReturn: currentTime,
    doDateTime: currentTime,
    tripDuration: 0,
    vehicleTypeId: 0,
    noOfPax: 1,
    noOfPaxReturn: 1,
    luggage: 0,
    noOfTrip: 1,
    isAccessible: false,
    isVipTrip: false,
    isPriorityTrip: false,
    isMeetGreet: false,
    tripTypeId: '1',
    isLockRates: false,
    recurringTypeId: 2,
    recurringEndDate: '',
    selectedDays: [],
    isWeekSun: false, isWeekMon: false, isWeekTue: false, isWeekWed: false, isWeekThu: false, isWeekFri: false, isWeekSat: false,
    isMonthSun: false, isMonthMon: false, isMonthTue: false, isMonthWed: false, isMonthThu: false, isMonthFri: false, isMonthSat: false,
    specialInstruction: '', permanentRemark: '', pickupNotes: '', billToNotes: '',
    customerRateTax: null,
    paymentTypeId: 1,
    voucherCompanyId: 0,
    paymentTermId: 1,
    existingCardId: 0,
    cardExpiry: '', cardType: '', creditCard: '',
    checkNumber: '', checkDate: '', checkBank: '', chargeTo: '', voucherCode: '',
    rideAmount: 0.0, tollAmount: 0.0, tipAmount: 0.0, otAmount: 0.0, serviceFeeAmount: 0.0,
    fuelSurcharge: 0.0, parkingFee: 0.0, tourGuideCharge: 0.0, payToTourGuide: 0.0,
    extraAmount: 0.0, extraAmountFor: '', waitingCharge: 0.0, waitingTime: 0, waitingChargeTotal: 0.0,
    extraStopCharge: 0.0, noOfStops: 0, stopTotal: 0.0, meetGreet: 0.0,
    mgToPay: '2', payMeetGreetId: 0, payMeetGreetAmount: 0.0, mgDriverComms: '1',
    agentCommissionId: 0, agentCommissionName: '', agentCommissionAmount: 0.0, discount: 0.0,
    portAuthority: 0.0, utitity: 0.0, countyTax: 0.0, congestionTax: 0.0, workCompantation: 0.0,
    salesTax: 0.0, grossAmount: 0.0, totalFare: 0.0, paidAmount: 0.0,
    loadPanelVisible: false, isCopy: false, isAttachment: false,
    chkPaymentGatewaySelection: '2',
  });
}
